module.exports = __webpack_public_path__ + "img/certifigrate_model.c70afdf0.jpg";